import axiosInstance from "./axiosInstance";
import { variables } from "./variables"



const API_URL = variables.FACILITYS_API;

export const fetchFacility = async () => {
    const response = await axiosInstance.get(API_URL);
    return response.data;
}